import { Component } from 'react'

import { IField } from '@features/forms'

export interface IProps {
  autoComplete?: string
  name: string
  label: string
  field: IField
  optional?: boolean
  disabled?: boolean
  icon?: any
  placeholder?: string
  /** Help text to aid in use of the field */
  info?: string
  onFocus?: (n: string) => any
  onBlur: (n: string) => any
  onChange: (n: string, v: any) => any
}

interface Field<P = {}, S = {}> {}

abstract class Field<P, S> extends Component<P & IProps, S> {
  constructor(props: P & IProps) {
    super(props)
    this.handleFocus = this.handleFocus.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.handleBlur = this.handleBlur.bind(this)
  }

  handleFocus() {
    const { name, onFocus } = this.props
    if (onFocus) {
      onFocus(name)
    }
  }

  handleChange({ target }: any) {
    const { name } = this.props
    this.props.onChange(name, target.value)
  }

  handleBlur(x: any) {
    const { name } = this.props
    this.props.onBlur(name)
  }
}

export default Field
